import React from 'react';
import DefaultLayout from '../../layouts/default';
import { RotaDashboardProvider } from './context/RotaDashboardContext';
import RotaDashboard from './components/RotaDashboard';
export default function RotaPage() { return <DefaultLayout className="p-10"><RotaDashboardProvider><RotaDashboard /></RotaDashboardProvider></DefaultLayout>; }
